/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowDecision } from './ShadowDecision';
import {
    ShadowDecisionFromJSON,
    ShadowDecisionFromJSONTyped,
    ShadowDecisionToJSON,
} from './ShadowDecision';

/**
 * 
 * @export
 * @interface GetLeadShadowDecision200Response
 */
export interface GetLeadShadowDecision200Response {
    /**
     * 
     * @type {ShadowDecision}
     * @memberof GetLeadShadowDecision200Response
     */
    data?: ShadowDecision;
}

/**
 * Check if a given object implements the GetLeadShadowDecision200Response interface.
 */
export function instanceOfGetLeadShadowDecision200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLeadShadowDecision200ResponseFromJSON(json: any): GetLeadShadowDecision200Response {
    return GetLeadShadowDecision200ResponseFromJSONTyped(json, false);
}

export function GetLeadShadowDecision200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadShadowDecision200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ShadowDecisionFromJSON(json['data']),
    };
}

export function GetLeadShadowDecision200ResponseToJSON(value?: GetLeadShadowDecision200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ShadowDecisionToJSON(value.data),
    };
}

